import React from 'react'
import PropTypes from 'prop-types'

import AdvancedFilter from 'component/trackingMonitor/AdvancedFilter'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Glyph from 'component/utils/Glyph'
import { formatDocument } from 'utils/masks'

const EMPTY = '-'

const Table = ({
  onSubmit,
  openRemoveModal,
  openViewModal,
  records,
  storeFull,
  translate,
}) => {
  const renderRow = (record) => (
    <tr key={record.header.orderNumber}>
      <td>
        {record.header.requestOriginType === 'APP'
          ? record.header.idOrder
          : EMPTY}
      </td>
      <td>{record.header.orderNumber}</td>
      <td>{record.header.customer.name}</td>
      <td>{formatDocument(record.header.customer.document, translate)}</td>
      <td>{formatStoreName(storeFull)}</td>
      <td className='action-icon-wrapper'>
        <span onClick={() => openViewModal(record)} className='action-icon'>
          <Glyph type='eye' color='primary' />
        </span>
      </td>
      <td className='action-icon-wrapper'>
        <span onClick={() => openRemoveModal(record)} className='action-icon'>
          <Glyph type='trash-can' color='danger' />
        </span>
      </td>
    </tr>
  )

  const formatStoreName = (storeFull) => {
    if (storeFull) {
      return storeFull.replace('LOJA ', '').substring(2)
    }

    return EMPTY
  }

  const renderMessage = () => (
    <div className='tracking-monitor-error'>
      {translate('totem.trackingMonitor.table.message')}
    </div>
  )

  return (
    <Row className='tracking-monitor-wrapper'>
      <Col xs={12}>
        <AdvancedFilter onSubmit={onSubmit} translate={translate} />

        <div className='tracking-monitor-table-wrapper'>
          <table className='tracking-monitor-table'>
            <thead>
              <tr>
                <th>{translate('totem.trackingMonitor.table.token')}</th>
                <th>{translate('totem.trackingMonitor.table.orderNumber')}</th>
                <th>{translate('totem.trackingMonitor.table.customerName')}</th>
                <th>{translate('totem.trackingMonitor.table.document')}</th>
                <th>{translate('totem.trackingMonitor.table.store')}</th>
                <th className='text-align-center'>
                  {translate('totem.trackingMonitor.table.viewOrder')}
                </th>
                <th className='text-align-center'>
                  {translate('totem.trackingMonitor.table.removeOrder')}
                </th>
              </tr>
            </thead>
            <tbody>{!!records.length && records.map(renderRow)}</tbody>
          </table>
        </div>

        {!records.length && renderMessage()}
      </Col>
    </Row>
  )
}

Table.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  openRemoveModal: PropTypes.func.isRequired,
  openViewModal: PropTypes.func.isRequired,
  records: PropTypes.array.isRequired,
  storeFull: PropTypes.string.isRequired,
  translate: PropTypes.func.isRequired,
}

export default Table
